import React from 'react';
import "../styles/steps.css";

const ProjectReview = ({ formData, updateFormData, setStepValidation, stepNumber, onGenerateProjectPlan, goToStep }) => {
    // Handle changes for editable fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        updateFormData({ ...formData, [name]: value });
    };
    // ✅ Handle generating project plan
    const handleGenerateProjectPlan = () => {
        onGenerateProjectPlan();  // Call the provided function to proceed
    };
    return (
        <div className="step-container">
            {/* <h2 className="step-heading">Review Your Project</h2> */}
            <p className="step-description">
                Before you take the plunge, give your project details a quick once-over! You can tweak the Project Name, Start Date, Budget, and Estimated Hours right here. For everything else, just click on the section header—like a secret portal—or use the progress bar to jump between steps (as long as you don’t let the session expire or refresh the page—because, well, life happens! 😆). Oh, and don’t forget to save your progress—future you will thank you for it! 🚀
            </p>

            {/* Editable Project Details */}
            <div className="review-section">
                <h3 className="section-title">Project Details</h3>
                <div className="input-group">
                    {/* ✅ Project Name & Start Date in One Row */}
                    <div className="review-input-row">
                        <div className="review-input-wrapper flex-grow-2">  {/* ✅ Gives Project Name more width */}
                            <label className="review-inline-label">Project Name:</label>
                            <input
                                type="text"
                                name="projectName"
                                value={formData.projectName}
                                onChange={handleChange}
                                className="input-field full-width"
                            />
                        </div>
                        <div className="review-input-wrapper flex-grow-1"> {/* ✅ Smaller width for Start Date */}
                            <label className="review-inline-label">Start Date:</label>
                            <input
                                type="date"
                                name="startDate"
                                value={formData.startDate}
                                onChange={handleChange}
                                className="input-field small-width"
                            />
                        </div>
                    </div>

                    {/* ✅ Budget & Estimated Hours in One Row */}
                    <div className="review-input-row">
                        <div className="review-input-wrapper flex-grow-1">
                            <label className="review-inline-label">Budget ($):</label>
                            <input
                                type="number"
                                name="budget"
                                value={formData.budget}
                                onChange={handleChange}
                                className="input-field small-width"
                            />
                        </div>
                        <div className="review-input-wrapper flex-grow-1">
                            <label className="review-inline-label">Estimated Hours:</label>
                            <input
                                type="number"
                                name="estimatedHours"
                                value={formData.estimatedHours}
                                onChange={handleChange}
                                className="input-field small-width"
                            />
                        </div>
                    </div>
                </div>



            </div>

            {/* Non-Editable Sections (Clickable to Navigate) */}
            <div className="review-section" onClick={() => goToStep(3)}>
            <h3 className="section-title">Implementation Type :</h3>
                <div className='review-input-row'>{formData.implementationType}</div>

            </div>

            {/* Preferred Resources & Tech Stack - Two Column Layout */}
            <div className="review-section two-column">
                {/* Preferred Resources */}
                <div className="column-section" onClick={() => goToStep(4)}>
                    <h3 className="section-title">Preferred Resources</h3>
                    <ul>
                        {formData.preferredResources.map((resource, index) => (
                            <li key={index}>
                                {resource.name} - ${resource.hourlyRate}/hr (Count: {resource.count})
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Tech Stack */}
                <div className="column-section" onClick={() => goToStep(5)}>
                    <h3 className="section-title">Tech Stack</h3>
                    <ul>
                        {formData.techStack.map((tech, index) => (
                            <li key={index}>{tech}</li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Sprint/Milestone Deliverables */}
            <div className="review-section" onClick={() => goToStep(6)}>
                <h3 className="section-title">Sprints/Milestones Deliverables</h3>
                <ul>
                    {formData.sprintsMilestones.map((milestone, index) => (
                        <li key={index}>
                            {milestone.name} - {milestone.duration} weeks
                        </li>
                    ))}
                </ul>
            </div>

            {/* Project Expenses - Includes total price in the header */}
            <div className="review-section" onClick={() => goToStep(7)}>
                <h3 className="section-title">
                    Project Expenses (Materials & Services) - Total: $
                    {formData.projectExpenses.reduce((sum, expense) => sum + (expense.unitPrice * expense.quantity), 0)}
                </h3>
                <table className="expenses-table">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Unit Price</th>
                            <th>Quantity</th>
                            <th>Total Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formData.projectExpenses.map((expense, index) => (
                            <tr key={index}>
                                <td>{expense.item}</td>
                                <td>${expense.unitPrice.toFixed(2)}</td>
                                <td>{expense.quantity}</td>
                                <td>${(expense.unitPrice * expense.quantity).toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Additional Comments */}
            <div className="review-section">
                <h3 className="section-title">Additional Comments</h3>
                <textarea
                    name="comments"
                    value={formData.comments}
                    onChange={handleChange}
                    className="input-field"
                    placeholder="Add any additional comments..."
                />
            </div>

            {/* Generate Project Summary Button */}
            <div className="flex justify-center mt-6">
                <button
                    onClick={handleGenerateProjectPlan}
                    className="px-6 py-3 bg-green-600 text-white rounded hover:bg-green-700"
                >
                    Generate Project Summary
                </button>
            </div>
        </div>
    );
};

export default ProjectReview;
